import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = ['Plan de alimentación desinflamatorio', 'Protocolo para eliminar sudores nocturnos', 'Guía de suplementos naturales fáciles de conseguir.'];
  return <section ref={ref} className="py-16 md:py-24 bg-[#faf6ee]" data-id="element-96">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-98">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-99">
            <div className="order-2 md:order-1" data-id="element-100">
              <div className="bg-white rounded-lg p-8 shadow-lg" data-id="element-101">
                <div className="flex items-center gap-3 mb-6" data-id="element-102">
                  <BookOpenIcon className="w-8 h-8 text-[#5d6e4f]" data-id="element-103" />
                  <h3 className="font-serif text-2xl text-[#2d2d2d]" data-id="element-104">
                    EL PROTOCOLO MENO-METABÓLICO
                  </h3>
                </div>

                <p className="text-lg text-[#7a8a6b] mb-6" data-id="element-105">
                  (Ebook PDF de 60 páginas)
                </p>

                <p className="text-lg text-[#2d2d2d] mb-8" data-id="element-106">
                  El mapa digital para transformar tu salud en 3 semanas:
                </p>

                <ul className="space-y-4" data-id="element-107">
                  {features.map((feature, index) => <motion.li key={index} initial={{
                  opacity: 0,
                  x: -20
                }} animate={isInView ? {
                  opacity: 1,
                  x: 0
                } : {}} transition={{
                  duration: 0.5,
                  delay: index * 0.1
                }} className="flex items-start gap-3" data-id="element-108">
                      <CheckIcon className="w-6 h-6 text-[#5d6e4f] flex-shrink-0 mt-1" data-id="element-109" />
                      <span className="text-lg text-[#2d2d2d]" data-id="element-110">{feature}</span>
                    </motion.li>)}
                </ul>
              </div>
            </div>

            <div className="order-1 md:order-2" data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/hmS7w43reDpjcC1KX8HJp8/Portada.png" alt="El Protocolo Meno-Metabólico Ebook" className="w-full max-w-sm mx-auto rounded-lg shadow-2xl" data-id="element-112" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}